// Components
import { TextMaskReveal } from '../ui/TextMaskReveal/TextMaskReveal';

// Types
type SecurityBadge = {
  name: string;
  src: string;
  alt: string;
};

const SECURITY_BADGES: SecurityBadge[] = [
  { name: 'ISO', src: '/img/why-trust-archie/iso.svg', alt: 'ISO 27001 Certified' },
  { name: 'SOC2', src: '/img/why-trust-archie/soc2.svg', alt: 'SOC 2 Type 1 Certified' },
  { name: 'GDPR', src: '/img/why-trust-archie/gdpr.svg', alt: 'GDPR Compliant' },
];

export const TrustSection = () => {
  return (
    <section
      id="security"
      className="flex flex-col items-center gap-[var(--spacing-32)] px-[var(--spacing-24)] py-[var(--spacing-96)] w-full max-w-[1224px] max-lg:px-[var(--spacing-24)] max-lg:py-[var(--spacing-64)] max-md:px-[var(--spacing-16)] max-md:py-[var(--spacing-48)] max-md:gap-[var(--spacing-24)]"
    >
      <TextMaskReveal
        as="span"
        variant="column-header"
        className="text-blue-1000"
        duration={0.6}
      >
        SECURE BY DESIGN
      </TextMaskReveal>

      <TextMaskReveal
        as="h2"
        variant="h1"
        className="text-blue-1000 text-center"
        duration={0.8}
        delay={0.1}
      >
        Why Trust Archie
      </TextMaskReveal>

      <TextMaskReveal
        as="p"
        variant="h3"
        className="text-blue-1000 text-center max-w-[808px]"
        staggerDelay={0.12}
        duration={0.8}
        delay={0.2}
      >
        Archie will never train on your firm's data. Ever.
        {'\n'}
        {'\n'}
        Your client information, workpapers, and financial data stay completely
        {'\n'}
        private. Archie is built with firm-grade security and compliance
        {'\n'}
        standards from the ground up, not bolted on as an afterthought.
      </TextMaskReveal>

      <div className="flex items-center gap-[var(--spacing-72)] py-[var(--spacing-32)] max-lg:gap-[var(--spacing-48)] max-md:flex-wrap max-md:justify-center max-md:gap-[var(--spacing-32)]">
        {SECURITY_BADGES.map((badge) => (
          <img
            key={badge.name}
            src={badge.src}
            alt={badge.alt}
            className="h-[115px] w-auto max-lg:h-[100px] max-md:h-[90px]"
          />
        ))}
      </div>
    </section>
  );
};
